// 🏗️ FSD Shared Layer - Pricing Constants
// PricingPage에서 사용되는 모든 상수 정의
/**
 * 반응형 브레이크포인트 정의
 */ export var breakpoints = {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px'
};
/**
 * Payment API 설정
 */ export var apiBase = 'https://pay.ugot.uk'; // 기본값, 실제로는 환경변수에서 가져옴
/**
 * 제품 코드 상수
 */ export var PRODUCT_CODES = {
    EDUSENSE_PLATFORM: 'EDUSENSE_PLATFORM'
};
/**
 * 폴백 플랜 데이터 (API 실패 시 사용)
 */ export var fallbackPlans = [
    {
        id: 'free',
        name: '무료 플랜',
        price: '₩0/월',
        features: [
            '기본 IDE 기능',
            '월 10시간 AI 채팅',
            '개인 프로젝트 3개',
            '커뮤니티 지원',
            '기본 템플릿 제공'
        ],
        buttonText: '무료로 시작하기',
        description: '개인 학습용으로 완벽한 무료 플랜',
        amount: 0,
        productCode: 'FREE_PLAN',
        productPlanCode: 'FREE_PLAN',
        isBillingPlan: false,
        billingCycle: 'MONTHLY'
    },
    {
        id: 'beginner',
        name: '베이직 플랜',
        price: '₩29,000/월',
        features: [
            '모든 IDE 기능',
            '월 50시간 AI 채팅',
            '무제한 개인 프로젝트',
            '우선 지원',
            '고급 템플릿 제공',
            '코드 리뷰 AI',
            '실시간 협업 기능'
        ],
        buttonText: '베이직 플랜 선택',
        description: '개인 개발자를 위한 완전한 기능',
        recommended: true,
        amount: 29000,
        productCode: 'BEGINNER_MONTHLY',
        productPlanCode: 'BEGINNER_MONTHLY',
        isBillingPlan: true,
        billingCycle: 'MONTHLY'
    },
    {
        id: 'advanced',
        name: '프로 플랜',
        price: '₩59,000/월',
        features: [
            '모든 베이직 기능',
            '무제한 AI 채팅',
            '팀 프로젝트 관리',
            '고급 AI 모델 접근',
            '사용자 정의 템플릿',
            '팀 협업 도구',
            '고급 분석 대시보드',
            '우선 기술 지원'
        ],
        buttonText: '프로 플랜 선택',
        description: '전문 개발팀을 위한 고급 기능',
        amount: 59000,
        productCode: 'ADVANCED_MONTHLY',
        productPlanCode: 'ADVANCED_MONTHLY',
        isBillingPlan: true,
        billingCycle: 'MONTHLY'
    },
    {
        id: 'business',
        name: '비즈니스 플랜',
        price: '₩590,000/년',
        features: [
            '모든 프로 기능',
            '온프레미스 배포',
            '사용자 정의 통합',
            '전담 계정 관리자',
            '24/7 프리미엄 지원',
            '고급 보안 기능',
            'SSO 통합',
            '사용자 정의 교육'
        ],
        buttonText: '비즈니스 플랜 선택',
        description: '기업 환경에 최적화된 올인원 패키지',
        amount: 590000,
        productCode: 'BUSINESS_YEARLY',
        productPlanCode: 'BUSINESS_YEARLY',
        isBillingPlan: true,
        billingCycle: 'YEARLY'
    },
    {
        id: 'enterprise',
        name: '엔터프라이즈',
        price: '가격 미정',
        features: [
            '모든 비즈니스 기능',
            '온프레미스 배포',
            '사용자 정의 통합',
            '전담 계정 관리자',
            '24/7 프리미엄 지원',
            '고급 보안 기능',
            'SSO 통합',
            '사용자 정의 교육'
        ],
        buttonText: '영업팀 문의',
        description: '대규모 조직을 위한 맞춤형 솔루션',
        productCode: 'ENTERPRISE_YEARLY',
        productPlanCode: 'ENTERPRISE_YEARLY',
        isBillingPlan: true,
        billingCycle: 'YEARLY'
    }
];
/**
 * UI 애니메이션 설정
 */ export var animations = {
    transition: 'all 0.3s ease',
    hoverScale: 1.02,
    clickScale: 0.98
};
/**
 * 색상 상수
 */ export var colors = {
    primary: '#3b82f6',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    gradients: {
        primary: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        card: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
    }
};
